import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { BatchTransactionsPageRoutingModule } from './batch-transactions-routing.module';

import { BatchTransactionsPage } from './batch-transactions.page';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    BatchTransactionsPageRoutingModule
  ],
  declarations: [BatchTransactionsPage]
})
export class BatchTransactionsPageModule {}
